// ADR 23.9.26v §8 — the one offline event. Content-free, consent-gated through
// `capture()`, and the mirror of 10.9.26k's `tutor_session_storage_failed`:
// without it a browser that refuses IndexedDB shows an empty offline app, and
// nobody could tell "no one uses offline" from "offline cannot store".

import { capture } from '../telemetry/capture'

export type OfflineStorageOperation = 'open' | 'get' | 'set' | 'del'

export function offlineCacheStorageFailed(operation: OfflineStorageOperation): void {
  capture('offline_cache_storage_failed', { operation })
}

// ADR 29.9.26ag §1 — the probe loop's episode: one event when a report starts
// a loop, one when it ends. Content-free: no URL, no status, no error text.

/** How a probe loop ended — the board breaks every duration down by this. */
export type ProbeLoopEnding = 'probe' | 'browser_online' | 'other_online' | 'browser_offline' | 'response'

/**
 * Why a loop started (ADR 7.10.26ad §2): a failed request, or a launch that
 * painted its snapshot before the network answered.
 */
export type UnreachableReason = 'transport' | 'boot_deadline'

export function probeLoopStarted(reason: UnreachableReason): void {
  capture('offline_probe_loop_started', { reason })
}

export function probeLoopEnded(endedBy: ProbeLoopEnding, probes: number, durationMs: number): void {
  capture('offline_probe_loop_ended', { ended_by: endedBy, probes, duration_ms: durationMs })
}
